export enum SidebarType {
    settings,
    upload
}